import routes from '../../constants/routes';
import { store } from '../../redux/index';
import { setSignUpType } from '../../redux/auth/actions';

export const INFO = `${routes.SIGNUP}/info`;
export const SELECT = `${routes.SIGNUP}/select`;
export const BUSINESS_SELECT = `${routes.SIGNUP}/business/select`;
export const INSTRUCTIONS = `${routes.SIGNUP}/instructions`;
export const PROPERTY_SELECT = `${routes.SIGNUP}/property/select`;
export const USER_PHOTO = `${routes.SIGNUP}/user/photo`;
export const SIGNIN = '/login';
export const PROPERTY_PHOTO = `${routes.SIGNUP}/property/photo`;
export const PROPERTY_RETRY = `${routes.SIGNUP}/property/retry`;
export const HOUSEHOLD_SELECT = `${routes.SIGNUP}/household/select`;
export const HOUSEHOLD_REQUEST = `${routes.SIGNUP}/household/request`;
export const HOUSEHOLD_CONFIRM = `${routes.SIGNUP}/household/confirm`;
export const SIGNUP_COMPLETE = `${routes.SIGNUP}/properties/:pid`;
export const OUTREACH = `${routes.SIGNUP}/outreach`;
export const CONFIRM = `${routes.SIGNUP}/confirm`;
export const ACTIONSHEET = 'PROJECT_ACTIONSHEET';
export const INVALID_INVITATION = `${routes.SIGNUP}/invalid/invitation`;
export const DASHBOARD = '/dashboard/';
export const STREETDEAL = '/streetdeal/';

export const TYPE_GENERIC = 'SIGNUP_TYPE_GENERIC';
export const TYPE_GENERIC_HOUSEHOLD = 'SIGNUP_TYPE_GENERIC_HOUSEHOLD';
export const TYPE_GENERIC_HOUSEHOLD_INVITE =
  'SIGNUP_TYPE_GENERIC_HOUSEHOLD_INVITE';
export const TYPE_HOUSEHOLD_INVITE = 'SIGNUP_TYPE_HOUSEHOLD_INVITE';
export const TYPE_CONTACT_INVITE = 'SIGNUP_TYPE_CONTACT_INVITE';
export const TYPE_OUTREACH = 'SIGNUP_TYPE_OUTREACH';
export const TYPE_PROJECT_INVITE = 'SIGNUP_TYPE_PROJECT_INVITE';
export const TYPE_GENERIC_BUSINESS = 'SIGNUP_TYPE_GENERIC_BUSINESS';
export const TYPE_GENERIC_INVITE = 'SIGNUP_TYPE_GENERIC_INVITE';
export const TYPE_HOMEOWNER_REFERRAL_INVITE =
  'SIGNUP_TYPE_HOMEOWNER_REFERRAL_INVITE';
export const TYPE_DOOR_KNOCKING = 'DOOR_KNOCKING';

/** Sign up error codes from API */
export const EMAIL_CONFLICT = 'EMAIL_CONFLICT';
export const USER_PROPERTY_CONFLICT = 'USER_PROPERTY_CONFLICT';
export const PROPERTY_CONFLICT = 'PROPERTY_CONFLICT';

// TODO: revisit some of these flows - much of this is probably not needed anymore and we can clean it up

// configs for each of the step
// default to next for each route
// check branch patterns/options based on onSuccess/onFail
// nextConfig lets specific add flows have a slightly different routing
// handle initials in SignUpRouter
export const configs = {
  [SELECT]: {
    route: SELECT,
    next: INFO,
    nextConfig: {
      [TYPE_GENERIC_BUSINESS]: BUSINESS_SELECT,
    },
  },
  [INSTRUCTIONS]: {
    route: INSTRUCTIONS,
    next: INFO,
    data: {},
  },
  [INFO]: {
    route: INFO,
    replace: true,
    onSuccess: {
      [TYPE_GENERIC]: USER_PHOTO,
      [TYPE_GENERIC_HOUSEHOLD]: PROPERTY_RETRY,
      [TYPE_GENERIC_BUSINESS]: CONFIRM,
      [TYPE_CONTACT_INVITE]: USER_PHOTO,
      [TYPE_GENERIC_INVITE]: USER_PHOTO,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: USER_PHOTO,
      [TYPE_HOUSEHOLD_INVITE]: USER_PHOTO,
      [TYPE_PROJECT_INVITE]: USER_PHOTO,
      [TYPE_OUTREACH]: USER_PHOTO,
    },
    onError: {
      [TYPE_GENERIC]: HOUSEHOLD_SELECT,
      [TYPE_GENERIC_HOUSEHOLD]: HOUSEHOLD_REQUEST,
      [TYPE_CONTACT_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_GENERIC_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_HOUSEHOLD_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_PROJECT_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_OUTREACH]: HOUSEHOLD_SELECT,
    },
  },
  [HOUSEHOLD_SELECT]: {
    route: HOUSEHOLD_SELECT,
    onSuccess: {
      [TYPE_GENERIC]: HOUSEHOLD_REQUEST,
      [TYPE_CONTACT_INVITE]: HOUSEHOLD_REQUEST,
      [TYPE_GENERIC_INVITE]: HOUSEHOLD_REQUEST,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: HOUSEHOLD_REQUEST,
      [TYPE_HOUSEHOLD_INVITE]: HOUSEHOLD_REQUEST,
      [TYPE_PROJECT_INVITE]: HOUSEHOLD_REQUEST,
      [TYPE_OUTREACH]: HOUSEHOLD_REQUEST,
    },
    onError: {
      [TYPE_GENERIC]: PROPERTY_SELECT,
      [TYPE_CONTACT_INVITE]: PROPERTY_SELECT,
      [TYPE_GENERIC_INVITE]: PROPERTY_SELECT,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: PROPERTY_SELECT,
      [TYPE_HOUSEHOLD_INVITE]: PROPERTY_SELECT,
      [TYPE_PROJECT_INVITE]: PROPERTY_SELECT,
      [TYPE_OUTREACH]: PROPERTY_SELECT,
    },
  },
  [PROPERTY_RETRY]: {
    route: PROPERTY_RETRY,
    replace: true,
    onSuccess: {
      [TYPE_GENERIC_HOUSEHOLD]: HOUSEHOLD_REQUEST,
      [TYPE_GENERIC_HOUSEHOLD_INVITE]: HOUSEHOLD_REQUEST,
    },
    onError: {
      [TYPE_GENERIC_HOUSEHOLD]: USER_PHOTO,
      [TYPE_GENERIC_HOUSEHOLD_INVITE]: USER_PHOTO,
    },
  },

  [PROPERTY_SELECT]: {
    route: PROPERTY_SELECT,
    replace: true,
    next: USER_PHOTO,
  },
  [PROPERTY_PHOTO]: {
    route: PROPERTY_PHOTO,
    replace: true,
    next: SIGNUP_COMPLETE,

    nextConfig: {
      [TYPE_CONTACT_INVITE]: CONFIRM,
      [TYPE_GENERIC_INVITE]: CONFIRM,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: CONFIRM,
      [TYPE_PROJECT_INVITE]: ACTIONSHEET,
    },
  },
  [USER_PHOTO]: {
    route: USER_PHOTO,
    replace: true,
    next: SIGNUP_COMPLETE,
    nextConfig: {
      [TYPE_GENERIC_HOUSEHOLD_INVITE]: HOUSEHOLD_CONFIRM,
      [TYPE_HOUSEHOLD_INVITE]: CONFIRM,
    },
  },
  [SIGNIN]: {
    replace: true,
    route: SIGNIN,
    next: DASHBOARD,
    nextConfig: {
      [TYPE_HOUSEHOLD_INVITE]: CONFIRM,
      [TYPE_CONTACT_INVITE]: CONFIRM,
      [TYPE_GENERIC_INVITE]: CONFIRM,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: CONFIRM,
    },
    onSuccess: {
      [TYPE_GENERIC]: USER_PHOTO,
      [TYPE_GENERIC_HOUSEHOLD]: PROPERTY_RETRY,
      [TYPE_GENERIC_BUSINESS]: CONFIRM,
      [TYPE_CONTACT_INVITE]: USER_PHOTO,
      [TYPE_GENERIC_INVITE]: USER_PHOTO,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: USER_PHOTO,
      [TYPE_HOUSEHOLD_INVITE]: USER_PHOTO,
      [TYPE_PROJECT_INVITE]: USER_PHOTO,
    },
    onError: {
      [TYPE_GENERIC]: HOUSEHOLD_SELECT,
      [TYPE_GENERIC_HOUSEHOLD]: HOUSEHOLD_REQUEST,
      [TYPE_CONTACT_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_HOUSEHOLD_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_PROJECT_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_GENERIC_INVITE]: HOUSEHOLD_SELECT,
      [TYPE_HOMEOWNER_REFERRAL_INVITE]: HOUSEHOLD_SELECT,
    },
  },
  [HOUSEHOLD_REQUEST]: {
    route: HOUSEHOLD_REQUEST,
    next: USER_PHOTO,
  },
  [HOUSEHOLD_CONFIRM]: {
    route: HOUSEHOLD_CONFIRM,
    next: USER_PHOTO,
  },
  [SIGNUP_COMPLETE]: {
    ngRoute: '/properties/:pid/pro-list/dashboard',
  },
  [OUTREACH]: {
    route: OUTREACH,
    replace: true,
    onSuccess: {
      [TYPE_OUTREACH]: USER_PHOTO,
    },
    onError: {
      [TYPE_OUTREACH]: HOUSEHOLD_REQUEST,
    },
  },
  [CONFIRM]: {
    route: CONFIRM,
    nextConfig: {
      [TYPE_PROJECT_INVITE]: SIGNUP_COMPLETE,
      [TYPE_GENERIC_HOUSEHOLD]: USER_PHOTO,
    },
    onNext: {
      [TYPE_GENERIC_HOUSEHOLD]: () =>
        store.dispatch(setSignUpType(TYPE_GENERIC_HOUSEHOLD_INVITE)),
    },
    next: DASHBOARD,
  },
  [BUSINESS_SELECT]: {
    route: BUSINESS_SELECT,
    next: INFO,
  },
  [DASHBOARD]: {
    ngRoute: '/properties/:pid/dashboard/',
  },
  [STREETDEAL]: {
    ngRoute: '/properties/:pid/viewall/merchant/user_rewards_:uid',
  },
};
